export default "__VITE_ASSET__DJndzKWX__"